module.exports = __webpack_public_path__ + "static/img/333.4baac90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/333.png
// module id = jtFR
// module chunks = 0